/* "Sumale a tu Halloween" en la ficha (Ganga V2 Halloween, 12/10/2026). Lo carga snippets/combo-disfraz.liquid
   (que: 'sumale', donde: 'ficha') junto al carrusel.
   El carrusel usa el modo lista de la V2 (assets/cross-sell-gs.js, mode 'cart'), pensado para el cajón: ahí, al agregar,
   el tema redibuja el cajón y la tarjeta desaparece sola. En la ficha la tarjeta queda y el botón se quedaba en
   "Agregando..." sin abrir el cajón. Acá, cuando el carrito avisa que se actualizó (cartUpdate del tema o cart:refresh),
   el botón tocado pasa a "Agregado" y vuelve a "Agregar", y se abre el cajón, como con el resto de la ficha.
   No mide nada ni escucha el scroll. */
(function () {
  if (window.__gsComboXs) return;
  window.__gsComboXs = true;

  var pend = null;
  var vence = null;

  function abrirCajon() {
    var d = document.querySelector('cart-drawer');
    if (d && !d.hasAttribute('open') && typeof d.show === 'function') d.show();
  }

  function listo() {
    var b = pend;
    pend = null;
    clearTimeout(vence);
    if (!b) return;
    /* el panel de opciones (talle, color) ya se cierra y se limpia solo: solo falta el cajón */
    if (b.classList.contains('xsell__cta') && b.textContent === 'Agregando...') {
      b.disabled = false;
      b.textContent = 'Agregado';
      setTimeout(function () { if (b.textContent === 'Agregado') b.textContent = 'Agregar'; }, 1800);
    }
    abrirCajon();
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.gs-hw-xs .xsell__cta, .gs-hw-xs .xsell__qa-add') : null;
    if (!b || b.disabled) return;
    /* "Elegir" solo abre el panel de opciones: todavía no agrega nada */
    var card = b.closest('.xsell__card');
    if (b.classList.contains('xsell__cta') && card && card.querySelector('.xsell__qa')) return;
    pend = b;
    clearTimeout(vence);
    vence = setTimeout(function () { pend = null; }, 15000);
  }, true);

  document.addEventListener('cart:refresh', function () { setTimeout(listo, 0); });

  function iniciar() {
    var P = window.FoxTheme && FoxTheme.pubsub;
    if (P && P.subscribe && P.PUB_SUB_EVENTS) P.subscribe(P.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(listo, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
